module.exports = __webpack_public_path__ + "src/assets/img/stamp.883457b9.png";